import { defineComponent as _defineComponent } from 'vue'
import { checkIsRouteAuthorized } from "@/security/authorization";

export default /*#__PURE__*/_defineComponent({
  __name: 'TheNavbarMenuDocumentTab',
  setup(__props) {


return { __sfc: true,checkIsRouteAuthorized }
}

})